// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import updateCarouselProductsVariantSelection from "@west/App/Handlers/ProductCarousel/UpdateCarouselProductsVariantSelection";
import updateProductListVariantSelection from "@west/App/Handlers/ProductList/UpdateProductListVariantSelection";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const useLoadVariantsProduct = ({
    parentProduct,
    parentProductId,
    carouselId,
}: {
    parentProduct: ProductModel;
    parentProductId?: string;
    carouselId?: string;
}) => {
    const dispatch = useDispatch();
    /**
     * To select default selection at the first time
     */
    const [shouldUpdateDefaultSelection, setShouldUpdateDefaultSelection] = useState(true);

    // Set default variant selection on component mount
    useEffect(() => {
        if (!parentProductId || !shouldUpdateDefaultSelection) {
            return;
        }

        /**
         * Extract default variant selection
         */
        const defaultVariantSelection: SafeDictionary<string> = {};
        parentProduct.variantTraits?.forEach(variant => {
            defaultVariantSelection[variant.id] =
                variant.traitValues?.find(trait => trait.isDefault)?.id || variant.traitValues?.[0]?.id || "";
        });

        setShouldUpdateDefaultSelection(false);

        if (carouselId) {
            dispatch(
                updateCarouselProductsVariantSelection({
                    needToLoadChildren: false,
                    parentProductId,
                    variantSelection: defaultVariantSelection,
                    carouselId,
                }),
            );
        } else {
            dispatch(
                updateProductListVariantSelection({
                    needToLoadChildren: false,
                    parentProductId,
                    variantSelection: defaultVariantSelection,
                }),
            );
        }
    }, [parentProduct.id]);
};

export default useLoadVariantsProduct;
